export default __webpack_public_path__ + "static/media/spin.96e61ecb.svg";